var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container" }, [
    _c(
      "div",
      { staticClass: "fixedButton" },
      [
        _c(
          "vxe-button",
          {
            staticClass: "examineButton",
            attrs: { status: "success" },
            on: { click: _vm.savaBicType },
          },
          [_vm._v("保存")]
        ),
        _c(
          "vxe-button",
          { staticClass: "examineButton", on: { click: _vm.ReturnFun } },
          [_vm._v("返回")]
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "CertificateReleaseApplicationBox scrollBars",
        style: "height:" + (_vm.$store.state.app.height - 70) + "px;",
      },
      [
        _c(
          "div",
          { staticClass: "main-div" },
          [
            _c(
              "el-form",
              {
                ref: "bicTypeForm",
                staticClass: "UniformCss",
                attrs: {
                  inline: true,
                  model: _vm.FormData,
                  "label-width": "110px",
                  rules: _vm.rules,
                },
              },
              [
                _c("div", { staticClass: "formLine" }, [_vm._v("值列表信息")]),
                _c(
                  "div",
                  { staticClass: "budgetBox" },
                  [
                    _c(
                      "el-row",
                      {
                        staticStyle: { "margin-top": "20px" },
                        attrs: { gutter: 5 },
                      },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "code",
                                  label: "类型编码",
                                  rules: { required: true, trigger: "blur" },
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "200px" },
                                  attrs: { disabled: _vm.isDisabled },
                                  model: {
                                    value: _vm.FormData.code,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.FormData, "code", $$v)
                                    },
                                    expression: "FormData.code",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "name",
                                  rules: { required: true, trigger: "blur" },
                                },
                              },
                              [
                                _c(
                                  "label",
                                  { attrs: { slot: "label" }, slot: "label" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "el-item-label" },
                                      [_vm._v("类型名称")]
                                    ),
                                  ]
                                ),
                                _c("el-input", {
                                  staticStyle: { width: "200px" },
                                  model: {
                                    value: _vm.FormData.name,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.FormData, "name", $$v)
                                    },
                                    expression: "FormData.name",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "orderNo",
                                  rules: { required: true, trigger: "blur" },
                                },
                              },
                              [
                                _c(
                                  "label",
                                  { attrs: { slot: "label" }, slot: "label" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "el-item-label" },
                                      [_vm._v("顺序号")]
                                    ),
                                  ]
                                ),
                                _c("a-input-number", {
                                  staticStyle: { width: "200px" },
                                  attrs: {
                                    "controls-position": "right",
                                    min: 0,
                                    max: 10000,
                                  },
                                  model: {
                                    value: _vm.FormData.orderNo,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.FormData, "orderNo", $$v)
                                    },
                                    expression: "FormData.orderNo",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "status",
                                  rules: { required: true, trigger: "blur" },
                                },
                              },
                              [
                                _c(
                                  "label",
                                  { attrs: { slot: "label" }, slot: "label" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "el-item-label" },
                                      [_vm._v("状态")]
                                    ),
                                  ]
                                ),
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "200px" },
                                    attrs: { placeholder: "请选择" },
                                    model: {
                                      value: _vm.FormData.status,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.FormData, "status", $$v)
                                      },
                                      expression: "FormData.status",
                                    },
                                  },
                                  _vm._l(_vm.statusOptions, function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { prop: "remark" } },
                              [
                                _c(
                                  "label",
                                  { attrs: { slot: "label" }, slot: "label" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "el-item-label" },
                                      [_vm._v("备注")]
                                    ),
                                  ]
                                ),
                                _c("el-input", {
                                  staticStyle: { width: "200px" },
                                  attrs: {
                                    type: "textarea",
                                    rows: 3,
                                    placeholder: "请输入",
                                  },
                                  model: {
                                    value: _vm.FormData.remark,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.FormData, "remark", $$v)
                                    },
                                    expression: "FormData.remark",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("br"),
                  ],
                  1
                ),
                _c("div", { staticClass: "formLine" }, [_vm._v("值列表取值")]),
                _c(
                  "div",
                  { staticStyle: { margin: "5px 0 5px 0px" } },
                  [
                    _c(
                      "vxe-button",
                      {
                        attrs: { status: "primary", icon: "el-icon-plus" },
                        on: {
                          click: function ($event) {
                            return _vm.insertEvent()
                          },
                        },
                      },
                      [_vm._v("新建")]
                    ),
                    _c(
                      "vxe-button",
                      {
                        attrs: { status: "danger", icon: "el-icon-delete" },
                        on: {
                          click: function ($event) {
                            return _vm.deleteValue()
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "budgetBox" },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "OBform",
                        attrs: {
                          "label-width": "1px",
                          model: _vm.modelTableBaseB,
                        },
                      },
                      [
                        _c(
                          "vxe-table",
                          {
                            ref: "xTable",
                            staticClass: "mytable-scrollbar",
                            attrs: {
                              border: "",
                              "show-header-overflow": "",
                              "show-overflow": "",
                              "column-config": { resizable: true },
                              stripe: "",
                              round: "",
                              loading: _vm.listLoading,
                              align: _vm.allAlign,
                              "edit-config": { trigger: "manual", mode: "row" },
                              "scroll-y": { enabled: false },
                              "edit-rules": _vm.validRules,
                              "row-config": { isHover: true },
                              data: _vm.currentTableData,
                            },
                          },
                          [
                            _c("vxe-column", {
                              attrs: { type: "checkbox", width: "60" },
                            }),
                            _c("vxe-column", {
                              attrs: {
                                type: "seq",
                                title: "序号",
                                width: "60",
                                align: "center",
                              },
                            }),
                            _c("vxe-column", {
                              attrs: {
                                visible: false,
                                field: "id",
                                title: "id",
                                align: "center",
                              },
                            }),
                            _c("vxe-column", {
                              attrs: {
                                field: "value",
                                title: "取值",
                                align: "center",
                                "edit-render": {},
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "edit",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return [
                                      _c("vxe-input", {
                                        attrs: {
                                          type: "text",
                                          placeholder: "请输入值编码",
                                        },
                                        model: {
                                          value: row.value,
                                          callback: function ($$v) {
                                            _vm.$set(row, "value", $$v)
                                          },
                                          expression: "row.value",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _c("vxe-column", {
                              attrs: {
                                field: "name",
                                title: "名称",
                                align: "center",
                                "edit-render": {},
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "edit",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return [
                                      _c("vxe-input", {
                                        attrs: {
                                          type: "text",
                                          placeholder: "请输入值名称",
                                        },
                                        model: {
                                          value: row.name,
                                          callback: function ($$v) {
                                            _vm.$set(row, "name", $$v)
                                          },
                                          expression: "row.name",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _c("vxe-column", {
                              attrs: {
                                field: "orderNo",
                                title: "顺序号",
                                align: "center",
                                "edit-render": {},
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "edit",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return [
                                      _c("a-input-number", {
                                        attrs: {
                                          "controls-position": "right",
                                          min: 0,
                                          max: 10000,
                                        },
                                        model: {
                                          value: row.orderNo,
                                          callback: function ($$v) {
                                            _vm.$set(row, "orderNo", $$v)
                                          },
                                          expression: "row.orderNo",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _c("vxe-column", {
                              attrs: {
                                field: "status",
                                title: "状态",
                                align: "center",
                                "edit-render": {},
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return [
                                      row.status === "1"
                                        ? _c("span", [_vm._v("有效")])
                                        : _c("span", [_vm._v("无效")]),
                                    ]
                                  },
                                },
                                {
                                  key: "edit",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return [
                                      _c(
                                        "vxe-select",
                                        {
                                          attrs: { transfer: "" },
                                          model: {
                                            value: row.status,
                                            callback: function ($$v) {
                                              _vm.$set(row, "status", $$v)
                                            },
                                            expression: "row.status",
                                          },
                                        },
                                        _vm._l(
                                          _vm.statusOptions,
                                          function (item) {
                                            return _c("vxe-option", {
                                              key: item.value,
                                              attrs: {
                                                value: item.value,
                                                label: item.label,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _c("vxe-column", {
                              attrs: {
                                field: "remark",
                                title: "备注",
                                align: "center",
                                "edit-render": {},
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "edit",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return [
                                      _c("vxe-input", {
                                        attrs: {
                                          type: "text",
                                          placeholder: "请输入备注",
                                        },
                                        model: {
                                          value: row.remark,
                                          callback: function ($$v) {
                                            _vm.$set(row, "remark", $$v)
                                          },
                                          expression: "row.remark",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _c("vxe-column", {
                              attrs: { title: "操作", width: "160" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return [
                                      _vm.$refs.xTable.isActiveByRow(row)
                                        ? [
                                            _c(
                                              "vxe-button",
                                              {
                                                attrs: { status: "success" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.savaBicValType(
                                                      row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("保存")]
                                            ),
                                            _c(
                                              "vxe-button",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.cancelRowEvent(
                                                      row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("取消")]
                                            ),
                                          ]
                                        : [
                                            _c(
                                              "vxe-button",
                                              {
                                                attrs: { status: "primary" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.editRowEvent(row)
                                                  },
                                                },
                                              },
                                              [_vm._v("编辑")]
                                            ),
                                          ],
                                    ]
                                  },
                                },
                              ]),
                            }),
                          ],
                          1
                        ),
                        _c("vxe-pager", {
                          attrs: {
                            loading: _vm.listLoading,
                            "current-page": _vm.tablePage.currentPage,
                            "page-size": _vm.tablePage.pageSize,
                            total: _vm.tablePage.totalResult,
                            layouts: [
                              "PrevPage",
                              "JumpNumber",
                              "NextPage",
                              "FullJump",
                              "Sizes",
                              "Total",
                            ],
                          },
                          on: { "page-change": _vm.handlePageChange },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }